import styled from 'styled-components';

interface ButtonProps {
  isAccept?: boolean;
}

export const CardContainer = styled.div`
  background-color: #e1ff2b;
  border-radius: 16px;
  padding: 21px 35px 32px 35px;
  width: 45%;
  min-height: 255px;
  min-width: 300px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;

  .userName {
    position: relative;
    display: inline-block;
    font-size: 1.5em;
    color: #000000;
    width: fit-content;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      bottom: -4px;
      height: 2px;
      background-color: #000000;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.4s ease-in-out;
    }
  }

  :hover {
    transform: translate(5px, -5px);
    background-color: #ccff2b;
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.2);

    .userName::after {
      transform: scaleX(1);
    }
  }

  @media screen and (max-width: 1368px) {
    width: 100%;
  }
`;

export const Header = styled.div`
  font-size: 24px;
  font-family: 'Graphik', sans-serif;
  font-weight: 500;
  line-height: 26px;
  color: #000;
  margin-top: 21px;
  margin-bottom: 16px;
`;

export const Infos = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 44px;
  color: #000;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .dot {
      display: none;
    }
  }
`;

export const Activity = styled.div`
  font-size: 14px;
  font-family: 'Graphik', sans-serif;
  font-weight: 400;
  line-height: 15px;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TimeInfo = styled.div`
  font-size: 14px;
  font-family: 'Graphik', sans-serif;
  font-weight: 500;
  line-height: 15px;
  color: #000;
`;

export const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;

  @media screen and (max-width: 1200px) {
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Button = styled.button<ButtonProps>`
  width: 100%;
  padding: 9px 12px 9px 18px;
  height: 42px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  color: #fff;
  background-color: ${({ isAccept }) => (isAccept ? '#A1B622' : '#8C8C8C')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  font-size: 13px;
  font-family: 'Graphik', sans-serif;
  font-weight: 500;
  line-height: 15px;

  &:hover {
    opacity: 0.9;
  }

  svg path {
    fill: #fff;
  }
`;

export const Icon = styled.span`
  margin-left: 8px;
  font-size: 1.25rem;
`;
